import { DefaultCustomizations } from '@uifabric/theme-samples';
import { Theme } from '@fluentui/theme';

export const FluentTheme: Theme = DefaultCustomizations.settings.theme;
